import { render, staticRenderFns } from "./CenterTop.vue?vue&type=template&id=e4fc536a&scoped=true"
import script from "./CenterTop.vue?vue&type=script&lang=js"
export * from "./CenterTop.vue?vue&type=script&lang=js"
import style0 from "./CenterTop.vue?vue&type=style&index=0&id=e4fc536a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fc536a",
  null
  
)

export default component.exports